module.exports = __webpack_public_path__ + "static/7-480c1689a299d34592dc24a082fa1fa0.svg";